import { Link } from "react-router";

const Hero = () => {
  return (
    <section id="hero" className="w-full ">
      <div className="max-w-7xl mx-auto px-4 py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ">
        <div>
          <span className="inline-block mb-4 text-sm font-semibold text-indigo-600 bg-indigo-100 px-4 py-1 rounded-full">
            Selamat Datang
          </span>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
            Temukan Pekerjaan <br className="hidden sm:block" />
            <strong className="text-indigo-600"> Impianmu </strong> Lebih Cepat
          </h1>

          <p className="text-gray-600 mb-8 max-w-xl">
            Platform lowongan kerja yang membantu job seeker menemukan peluang
            terbaik sesuai skill, pengalaman, dan tujuan karier.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to={"/job-vacancy"}
              className="px-6 py-3 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 transition">
              Cari Lowongan
            </Link>
            <Link
              to={"/about"}
              className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition">
              Tentang Kami
            </Link>
          </div>
        </div>

        <div className="flex flex-col items-center gap-8 ">
          <img
            src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
            alt="Job Seeker"
            className="hidden lg:block w-full max-w-md rounded-3xl object-cover"
          />
          <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-4 bg-gray-50 rounded-2xl py-2 px-2">
            <div className="bg-white rounded-xl p-4 shadow-sm text-center">
              <p className="text-2xl font-bold text-gray-900">1K+</p>
              <p className="text-sm text-gray-500">Lowongan Aktif</p>
            </div>
            <div className="bg-white rounded-xl p-4 shadow-sm text-center">
              <p className="text-2xl font-bold text-gray-900">300+</p>
              <p className="text-sm text-gray-500">Perusahaan</p>
            </div>
            <div className="bg-white rounded-xl p-4 shadow-sm text-center">
              <p className="text-2xl font-bold text-gray-900">50K+</p>
              <p className="text-sm text-gray-500">Job Seeker</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
